import Link from 'next/link'

import { TArticleItem } from 'store/types/article'

import { BASE_URL } from '@/shared/lib/const/env'
import Flex from '@/shared/ui/Flex/ui/Flex'
import { Image } from '@/shared/ui/Image'
import { Title } from '@/shared/ui/Typography'
import { TitleLevels } from '@/shared/ui/Typography/Title/Title'

import styles from './ArticleCard.module.scss'

export type ArticleCardProps = {
	LINK_PART?: string
	URLPATH: string
} & TArticleItem

/** A component that renders main info about promotion.
 * @param props
 * @param props.NAME
 * @param props.CODE - stock code in the system
 * @param props.PREVIEW_PICTURE
 * @param props.URLPATH
 * */
export const ArticleCard = ({
	NAME,
	CODE,
	PREVIEW_PICTURE,
	PREVIEW_TEXT = ``,
	URLPATH
}: ArticleCardProps): JSX.Element => (
	<article className={styles.articleCard}>
		<Link prefetch={false} href={`/${URLPATH}/${CODE}`}>
			<Flex column>
				<div className={styles.imageWrap}>
					{!!PREVIEW_PICTURE && <Image src={BASE_URL + PREVIEW_PICTURE} width={328} height={150} alt={NAME} />}
				</div>
				<div className={styles.text}>
					<Title as="h3" level={`${TitleLevels.H5}`} bottomOffset="2x">
						{NAME}
					</Title>
					<span className={styles.link}>{PREVIEW_TEXT}</span>
				</div>
			</Flex>
		</Link>
	</article>
)
